<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/129J37n/tc-custom/9781460334836.jpg?1740466879510" alt="This image is the cover for the book When Opposites Attract . . ., The Barrington Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When Opposites Attract . . ., The Barrington Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <p>"When I want something, I find a way to make it mine." <br/><br/>After a near-fatal accident, Hollywood hotshot Grant Carter never imagined returning to the equestrian world. But producing a movie about a racing dynasty means he has no choice. Luckily Tessa Barrington, star jockey, provides the distraction he needsfeisty attitude, stunning looksand a surprising innocence he can't resist. <br/><br/>Tessa won't give herself to just any man, especially a smooth-talking player like Grant. Once filming wraps, how can she trust he'll stick around? He's already keeping secrets. Besides, Tessa has her eye on bigger prizesunless falling in love is the biggest prize of all, for both of them.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jules Bennett
      </h2>
      
      <p class="authorDescription body article"><I>USA&#160;TODAY</I> Bestselling Author Jules Bennett has penned&#160;more than&#160;50 novels during her short career.&#160;She&#39;s married to her high school sweetheart, has two active girls, and is a former salon owner. Jules can be found on Twitter, Facebook (Fan Page), and her website julesbennett.com. She holds contests via these three outlets with each release and loves to hear from readers!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54ce331e